<template>
    <div class="bg-white p-6 shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">📈</span>
            <span>GPA trends by year of study</span>
        </h2>
        <apexchart type="bar" height="400" :options="chartOptions" :series="series" />
    </div>
</template>

<script>
import ApexChart from "vue3-apexcharts";

export default {
    name: "gpa-between-programs",
    components: {
        apexchart: ApexChart,
    },
    props: ["data"],
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    type: 'bar',
                    height: 400,
                    stacked: false,
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '60%',
                        endingShape: 'rounded'
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '10px'
                    }
                },
                stroke: {
                    show: true,
                    width: 1,
                    colors: ['#fff']
                },
                xaxis: {
                    categories: [],
                    labels: {
                        rotate: -45,
                        style: {
                            fontSize: '10px'
                        }
                    }
                },
                yaxis: [
                    {
                        title: {
                            text: 'Average GPA'
                        },
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                        },
                    },
                    {
                        opposite: true,
                        title: {
                            text: 'Number of Students',
                            style: {
                                fontSize: '10px',
                                fontWeight: 'bold',
                            },
                        }
                    }
                ],
                tooltip: {
                    style: {
                        fontSize: '12px',
                        fontWeight: 'bold',
                    },
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (val, opts) {
                            const seriesName = opts.w.config.series[opts.seriesIndex].name;
                            if (seriesName === 'Number of Students') {
                                return Math.round(val);
                            }
                            return val.toFixed(2);
                        }
                    },
                },
                colors: ['#00B8D9', '#36B37E'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'light',
                        type: 'vertical',
                        gradientToColors: ['#00B8D9', '#36B37E'],
                        opacityFrom: 0.7,
                        opacityTo: 1,
                        stops: [0, 100]
                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'center'
                }
            }
        };
    },
    watch: {
        data: {
            handler(newData) {
                if (!Array.isArray(newData)) return;

                const categories = [];
                const gpaValues = [];
                const studentCounts = [];

                newData.forEach(item => {
                    categories.push(item.year_of_study);
                    gpaValues.push(item.average_gpa);
                    studentCounts.push(parseInt(item.student_count));
                });

                this.series = [
                    {
                        name: 'Average GPA',
                        type: 'column',
                        data: gpaValues
                    },
                    {
                        name: 'Number of Students',
                        type: 'column',
                        data: studentCounts
                    }
                ];

                this.chartOptions = {
                    ...this.chartOptions,
                    xaxis: {
                        ...this.chartOptions.xaxis,
                        categories,
                    },
                };
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>